<template>
  <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
    <label
      v-for="option in options"
      :key="option.value"
      class="relative rounded-lg border px-6 py-5 flex items-start space-x-3 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
      :class="[
        value.indexOf(option.value) >= 0
          ? 'border-blue-300 bg-blue-100 shadow-sm hover:border-blue-400'
          : 'border-gray-300 bg-white hover:border-gray-400',
      ]"
    >
      <div class="flex-1 min-w-0">
        <input type="checkbox" :value="option.value" v-model="inputValue" class="hidden" />
        <p class="text-sm font-medium text-gray-900 truncate">
          {{ option.label }}
        </p>
        <p class="text-sm text-gray-500">
          {{ option.description }}
        </p>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
